import { isArray, isFunction, isNull, isUndefined } from '@isyscore/utils/type';
import { createError } from '../../create-error';
import { API_VERSION_RES_ORDER } from '../../order-define';
export const resApiVersion = (options) => {
    const options2 = options || {};
    const { successCode = (code) => [0, '0', 200, '200', 'ok', 'OK', 'success', 'SUCCESS'].includes(code) } = options2;
    const guessSuccess = isFunction(successCode)
        ? successCode
        : (code) => {
            if (isUndefined(successCode) || isNull(successCode))
                return true;
            if (isArray(successCode))
                return successCode.includes(code);
            return successCode === code;
        };
    return {
        resOrder: API_VERSION_RES_ORDER,
        resInterceptor(res) {
            Object.defineProperty(res, 'originalData', { value: res.data, enumerable: false });
            if (options2.version === '2.0') {
                const resData = res.data;
                const { code, data, message } = resData;
                res.data = data;
                if (!guessSuccess(code))
                    throw createError(message, res);
            }
            return res;
        }
    };
};
